import { render } from "./EditLabelDialog.vue?vue&type=template&id=287e3488"
import script from "./EditLabelDialog.vue?vue&type=script&lang=js"
export * from "./EditLabelDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__